var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.block && _vm.block.body
    ? _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _vm._l(_vm.block.body, function (b) {
            return [
              b.layout === "one"
                ? [
                    _c("v-flex", {
                      attrs: { xs12: "" },
                      domProps: { innerHTML: _vm._s(b.column) },
                    }),
                  ]
                : _vm._e(),
              b.layout === "50-50"
                ? [
                    _c("v-flex", {
                      attrs: { xs12: "", sm6: "" },
                      domProps: { innerHTML: _vm._s(b.columnLeft) },
                    }),
                    _c("v-flex", {
                      attrs: { xs12: "", sm6: "" },
                      domProps: { innerHTML: _vm._s(b.columnRight) },
                    }),
                  ]
                : _vm._e(),
              b.layout === "4-4-4"
                ? [
                    _c("v-flex", {
                      attrs: { xs12: "", sm4: "" },
                      domProps: { innerHTML: _vm._s(b.columnLeft) },
                    }),
                    _c("v-flex", {
                      attrs: { xs12: "", sm4: "" },
                      domProps: { innerHTML: _vm._s(b.columnCenter) },
                    }),
                    _c("v-flex", {
                      attrs: { xs12: "", sm4: "" },
                      domProps: { innerHTML: _vm._s(b.columnRight) },
                    }),
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }